import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoDetalleDescripcionAlineacionDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoDetalleDescripcionAlineacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getProyectoDetalleDescripcionAlineacionService(): Observable<
    BodyListResponse<ProyectoDetalleDescripcionAlineacionDTO>
  > {
    return this.http.get<
      BodyListResponse<ProyectoDetalleDescripcionAlineacionDTO>
    >(API_URL + '/api/v1/proyectoDetalleDescripcionAlineacion/todos');
  }

  guardarProyectoDetalleDescripcionAlineacionService(
    proyectoDetalleDescripcionAlineacionDTO: ProyectoDetalleDescripcionAlineacionDTO,
  ): Observable<BodyResponse<ProyectoDetalleDescripcionAlineacionDTO>> {
    return this.http.post<
      BodyResponse<ProyectoDetalleDescripcionAlineacionDTO>
    >(
      API_URL + '/api/v1/proyectoDetalleDescripcionAlineacion',
      proyectoDetalleDescripcionAlineacionDTO,
    );
  }

  getProyectoDetalleDescripcionAlineacionPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ProyectoDetalleDescripcionAlineacionDTO>> {
    return this.http.get<BodyResponse<ProyectoDetalleDescripcionAlineacionDTO>>(
      API_URL + '/api/v1/proyectoDetalleDescripcionAlineacion/' + codigo,
    );
  }
}
